var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"dashboard-card rounded-lg border border-gray-300 dark:border-gray-700 w-full text-gray-700 dark:text-gray-400 hover:bg-gray-100 dark-hover:bg-gray-900 transition duration-150"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }